import React, { useContext, useLayoutEffect, useState } from 'react'
import { IProviderProps } from '../@types/context'
import { IDimensions, IWindowSizeContext } from '../@types/window'
import useDebounce from '../helpers/useDebounce'

export const WindowSizeContext: React.Context<IWindowSizeContext> =
  React.createContext<IWindowSizeContext>({
    dimensions: {
      width: 0,
      height: 0,
    },
  })

export const WindowSizeProvider: React.FC<IProviderProps> = ({ children }) => {
  const [realtimeDimensions, setRealtimeDimensions] = useState({
    width: 0,
    height: 0,
  })
  const dimensions = useDebounce<IDimensions>(realtimeDimensions, 250)

  const handleResize = (): void => {
    const { innerWidth, innerHeight } = window
    setRealtimeDimensions({
      width: innerWidth,
      height: innerHeight,
    })
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <WindowSizeContext.Provider
      value={{
        dimensions,
      }}
    >
      {children}
    </WindowSizeContext.Provider>
  )
}

export const useWindowSize = (): IWindowSizeContext =>
  useContext(WindowSizeContext)
